import { DownloadButton } from '@anytag/shared-atoms';
import { ListWithPagination } from '@anytag/shared-molecules';
import { useDownloadFile, useParamsSearch } from '@anytag/shared-hooks';
import { useInfluencerAllInstagramFeedPostsQuery } from '@anytag/graphql';
import { convertOrderToORDER, getOffset, getUploadApiUrl, getValuableVariables } from '@anytag/shared-utils';
import {
  ProfilePostsCount,
  ProfilePostsFilter,
  InfluencerInstagramPostsList,
  InfluencerInstagramPostsListSearchType
} from '@anytag/shared-organisms';
import { useInitialInfluencerPostsListWithName } from '../hooks';

export const InfluencerInstagramPosts = () => {
  const { downloading, handleDownloadFile } = useDownloadFile();
  const { influencerId, mainSocialAccountId } = useInitialInfluencerPostsListWithName();
  const { page, limit, sort, filter, setFilter } = useParamsSearch<InfluencerInstagramPostsListSearchType>();
  const { data, previousData, loading } = useInfluencerAllInstagramFeedPostsQuery({
    skip: !influencerId || !mainSocialAccountId,
    variables: getValuableVariables({
      limit,
      socialAccountId: mainSocialAccountId,
      offset: getOffset(page, limit),
      orderBy: { field: sort.field, order: convertOrderToORDER(sort.order) },
      endDate: null,
      startDate: null,
      keyword: filter.keyword
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.influencerAllInstagramFeedPostsCount?.totalNumber;

  return (
    <ListWithPagination pagination={{ totalRecords }}>
      <ProfilePostsFilter filter={filter} setFilter={setFilter} />

      <ProfilePostsCount count={totalRecords}>
        <DownloadButton
          loading={downloading}
          onClick={() =>
            handleDownloadFile({
              filenamePrefix: 'feedPosts',
              url: getUploadApiUrl(`analytics/feed_posts/influencer/${mainSocialAccountId}/csv/custom`)
            })
          }
        />
      </ProfilePostsCount>

      <InfluencerInstagramPostsList
        loading={loading}
        mainSocialAccountId={mainSocialAccountId}
        data={result?.influencerAllInstagramFeedPosts || []}
      />
    </ListWithPagination>
  );
};
